import { useMemo } from 'react';

import { paywallActions, usePaywallStore } from '#/store/paywall/paywall.store';

// most of the things were already removed from here. maybe we can remove the whole thing later.
export const usePlanPickerActions = () => {
  const { closeHandler } = usePaywallStore();

  return useMemo(
    () => ({
      handleError: paywallActions.setError,
      handleClose: () => {
        if (!closeHandler?.isCancelOnly) {
          closeHandler?.onClose();
        }

        if (!closeHandler?.ignoreDefault) {
          paywallActions.closePaywall();
        }
      },
    }),
    [closeHandler]
  );
};
